'use strict';

const { parseTopBids, parseBidData } = require('./adformResponseParserHelpers');
const adformConstants = require('../adformConstants');
const { initClickEvent, initInViewportObserver } = require('../adformElementEvents');

/**
 * Returns array of parsed bid objects that can be used to generate html (img ad with link).
 * @param {Array} topBids - array of bids from response (sorted by price)
 * @return {Object[]} - array of parsed bid objects
 */
function getValidBids(topBids) {
    let validBids = [];
    for (let i = 0; i < topBids.length; i++) {
        const bid = topBids[i];
        const parsedBid = parseBidData(bid);
        if (!parsedBid) {
            // eslint-disable-next-line no-continue
            continue;
        }

        validBids.push(parsedBid);
    }

    return validBids;
}

/**
 * Handles adform returned bids (informs other modules e.g. to render "featured block" (component with products and banner))
 * @param {Object[]} bids - array of parsed bid objects (img, links...)
 * @param {Object} additionalEventData - additional data needed to process adform data
 */
function handleHasBids(bids, additionalEventData) {
    bids.forEach(function (bid, index) {
        const wrapper = additionalEventData.wrappers[index];
        const alt = bid.descriptionAltText || wrapper.getAttribute('data-alt') || 'Banner';
        const url = bid.linkURL;

        const parent = wrapper.closest('.product-tiles');
        parent.innerHTML = '';

        const markup = `
            <div class="rounded w-100 h-100 bg-black">
                <a href="${url}" class="d-flex align-items-center justify-content-center w-100 h-100">
                    <img
                        src="${bid.desktopImgURL}"
                        width="${bid.desktopImgWidth}"
                        height="${bid.desktopImgHeight}"
                        alt="${alt}"
                        loading="lazy"
                        class="d-horizontal-only rounded img-fluid ${adformConstants.BID_IMG_JS_CLASS} ${adformConstants.BID_INTERSECTION_INDICATOR_JS_CLASS}"
                    />
                    <img
                        src="${bid.mobileImgURL}"
                        width="${bid.mobileImgWidth}"
                        height="${bid.mobileImgHeight}"
                        alt="${alt}"
                        loading="lazy"
                        class="d-vertical-only rounded img-fluid ${adformConstants.BID_IMG_JS_CLASS}"
                    />
                </a>
            </div>
        `;

        parent.insertAdjacentHTML('beforeend', markup);

        const adformElement = parent.querySelector('a');
        initClickEvent(adformElement, bid);
        initInViewportObserver(adformElement, bid);
    });
}

/**
 * Handles when adform request if not valid
 * @param {Object} error - error from try and catch
 */
function handleError(error) {
    // eslint-disable-next-line no-console
    console.warn('Error:', error);
}

/**
 * Handles adform 200 code response that has bids data.
 * Converts bids from response into parsed objects that can be used for inserting ads (img, link...) and sends them with dispatchEvent.
 * If not valid bids, informs other modules (e.g. slider to remove placeholder loader...)
 *
 * @param {Object} data - adform response
 @param {Object} additionalEventData - additional data needed to process adform data
 */
function handleBidsResponse(data, additionalEventData) {
    try {
        const topBids = parseTopBids(data, adformConstants.LISTPAGE_TILE_BANNER_NUM_OF_BIDS);
        if (!topBids.length) {
            return;
        }

        let validBids = getValidBids(topBids);
        if (!validBids.length) {
            return;
        }
        handleHasBids(validBids, additionalEventData);
    } catch (e) {
        handleError(e, additionalEventData);
    }
}

module.exports = {
    handleError: handleError,
    handleBidsResponse: handleBidsResponse
};
